module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dynamic-right-panel"
  }, [_c('transition', {
    attrs: {
      "name": "slideright",
      "mode": "out-in"
    }
  }, [(_vm.currentComponent) ? _c('div', {
    staticClass: "md-layout-item md-content right",
    attrs: {
      "md-theme": "white"
    }
  }, [_c(_vm.currentComponent, {
    tag: "component"
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d162795","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicRightPanel.vue
// module id = 1158
// module chunks = 0